import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import moment from "moment";
import { Search } from "lucide-react";
import { getPatients } from "../../../api/api";
import DataTable from "../../../components/DataTable";
import { Input } from "../../../components/ui/input";

// Read-only — scoped to patients this doctor has actually seen (the backend
// forces doctor_id server-side regardless of what's sent here).
export default function MyPatients() {
  const doctorId = useSelector((s) => s.users.user?.doctor_id);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ total: 0, numberOfPage: 1 });

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      getPatients({ doctor_id: doctorId, search: search || undefined, page, limit: 15 })
        .then((res) => {
          setPatients(res.data);
          setMeta({ total: res.total, numberOfPage: res.numberOfPage });
        })
        .catch((err) => toast.error(err?.message || "Could not load patients."))
        .finally(() => setLoading(false));
    }, 200);
    return () => clearTimeout(t);
  }, [doctorId, search, page]);

  const columns = [
    {
      key: "name",
      header: "Patient",
      render: (p) => (
        <div>
          <p className="font-medium">{p.name}</p>
          <p className="text-xs text-muted-foreground">{p.phone}</p>
        </div>
      ),
    },
    { key: "gender", header: "Gender", render: (p) => p.gender || "—" },
    { key: "appointment_count", header: "Visits with you" },
    {
      key: "last_visit",
      header: "Last visit",
      render: (p) => (p.last_visit ? moment(p.last_visit).format("D MMM YYYY") : "—"),
    },
  ];

  return (
    <div className="space-y-4">
      <div>
        <h2 className="font-serif text-2xl font-semibold">My Patients</h2>
        <p className="text-sm text-muted-foreground">Patients you've seen</p>
      </div>

      <div className="relative max-w-sm">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search by name or phone…"
          className="pl-9"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
        />
      </div>

      <DataTable
        columns={columns}
        data={patients}
        loading={loading}
        emptyMessage="No patients found."
        page={page}
        numberOfPage={meta.numberOfPage}
        onPageChange={setPage}
        rowKey={(p) => p._id}
      />
    </div>
  );
}
